import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-the-c01-item-thumbnails-sp" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "js-button-prev p-the-c01-item-thumbnails-sp__toolbar__button" }
const _hoisted_4 = { class: "js-button-next p-the-c01-item-thumbnails-sp__toolbar__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_AppSwiper = _resolveComponent("AppSwiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppSwiper, {
      class: "swiper",
      options: _ctx.swiperOption
    }, {
      "button-prev": _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_IconBase, {
            "view-box": "0 0 24 24",
            width: "16",
            height: "16",
            "icon-color": "#b6b6b6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconArrowLeft)
            ]),
            _: 1
          })
        ])
      ]),
      pagination: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "js-pagination p-the-c01-item-thumbnails-sp__toolbar__count" }, null, -1)
      ])),
      "button-next": _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_IconBase, {
            "view-box": "0 0 24 24",
            width: "16",
            height: "16",
            "icon-color": "#b6b6b6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconArrowRight)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbnails, (thumbnail, key) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: key }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: thumbnail.image_url,
                class: "p-the-c01-item-thumbnails-sp__img"
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["options"])
  ]))
}